module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Drone.aa0eade.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Drone.jpg
// module id = na9A
// module chunks = 0